/* eslint-disable no-console */
import { logger } from '@talos/kyoko';

interface VersionCheckerConfig {
  onUpdate: (version: string) => void;
}

interface AppJson {
  version: string;
  hash: string;
}

const UPDATE_INTERVAL = 60_000;
const VERSION_URL = '/version.json';

/**
 * Fetches application version information from the server
 * @returns Promise resolving to app version data
 */
function fetchAppVersion(): Promise<AppJson> {
  return fetch(VERSION_URL).then(response => {
    if (!response.ok) {
      throw new Error('Could not check version');
    }
    return response.json() as Promise<AppJson>;
  });
}

export function registerVersionChecker(config: VersionCheckerConfig) {
  console.debug('Registering version checker...');
  // Store the initial hash to compare against future requests
  let initialHash: string | null = null;

  const checkVersion = () => {
    console.debug('Checking for updates...');
    fetchAppVersion()
      .then(appVersion => {
        const currentHash = appVersion.hash;

        if (!initialHash) {
          initialHash = currentHash;
          console.debug(`Version: ${appVersion.version} (${appVersion.hash})`);
          return;
        }

        // Notify about updates if the hash has changed
        if (currentHash !== initialHash) {
          console.debug(`New version available: ${appVersion.version} (${appVersion.hash})`);
          config.onUpdate(currentHash);
          initialHash = currentHash;
        }
      })
      .catch(error => {
        logger.error(error);
      });
  };
  // Initialize current version
  checkVersion();

  // Periodically check for updates
  setInterval(checkVersion, UPDATE_INTERVAL);
}
